// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightColumn":"SwQPF8","feedbackSuccessIcon":"_22fCJ9","textTitle":"_1XEVAE","reviewerEditorWrapper":"_2mAEh4","renderToolTip":"M5Jg3N"};